var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 67,
    viewBox: "0 0 102 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 67,
    rx: 8,
    fill: "#D2D2D2",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9167 55.4584H38.0834C30.3334 55.4584 25.1667 51.5834 25.1667 42.5417V24.4584C25.1667 15.4167 30.3334 11.5417 38.0834 11.5417H63.9167C71.6667 11.5417 76.8334 15.4167 76.8334 24.4584V42.5417C76.8334 51.5834 71.6667 55.4584 63.9167 55.4584Z",
    stroke: "#151B33",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41.25C55.2802 41.25 58.75 37.7802 58.75 33.5C58.75 29.2198 55.2802 25.75 51 25.75C46.7198 25.75 43.25 29.2198 43.25 33.5C43.25 37.7802 46.7198 41.25 51 41.25Z",
    stroke: "#151B33",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0834 20.5833H61.3334",
    stroke: "#151B33",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6667 46.4167H32.9167",
    stroke: "#151B33",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceIcon);
export default __webpack_public_path__ + "static/media/balanceIcon.02d217ce02155d9874427081502bacc9.svg";
export { ForwardRef as ReactComponent };